import { render, staticRenderFns } from "./right-top.vue?vue&type=template&id=dc18e890&scoped=true&"
import script from "./right-top.vue?vue&type=script&lang=js&"
export * from "./right-top.vue?vue&type=script&lang=js&"
import style0 from "./right-top.vue?vue&type=style&index=0&id=dc18e890&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc18e890",
  null
  
)

export default component.exports